import { render, staticRenderFns } from "./btn-bolder.mpx?vue&type=template&id=72d9fd1a&isComponent&outputPath=components%2Fbtn-bolder09bbf46b%2Findex"
import script from "./btn-bolder.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-bolder09bbf46b%2Findex"
export * from "./btn-bolder.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-bolder09bbf46b%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports